import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Row, Modal, Table, Form } from 'react-bootstrap'
import NavSearch from '../layouts/AdminLayout/NavBar/NavLeft/NavSearch';
import { getServerURL } from '../helper/envConfig';
import PaginationC from './pagination';
import Loader from './Loader/Loader';
import api from '../helper/api';
import { errorResponse } from '../helper/error';
import { toast } from 'react-toastify';

const ProductReview = (props) => {

  const serverURL = getServerURL()
  const [states, setStates] = useState({})
  const [modalShow, setModalShow] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [mode, setMode] = useState();
  const [validated, setValidated] = useState(false);
  const [subLoader, setSubLoader] = useState(false);

  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true);
  const [paginationData, setPaginationData] = useState({})
  const [page, setPage] = useState(1)

  useEffect(() => {
    getReview();
  }, [searchText, page]);

  useEffect(() => {
    if (searchText?.length) setPage(1);
  }, [searchText]);

  const getReview = (event) => {
    api.getWithToken(`${serverURL}review/?page=${page}${searchText && `&_s=${searchText}`}`)
      .then(async (res) => {
        const { data, links, page, page_size, total, total_pages } = res?.data;
        setPaginationData({ links, page, page_size, total, total_pages })
        setLoading(false)
        if (res?.data?.success === true) {
          setData(data);
        }
      })
      .catch((e) => {
        setLoading(false)
      });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setStates((prevValues) => ({
        ...prevValues,
        [name]: checked,
      }));
    } else {
      setStates((prevValues) => ({
        ...prevValues,
        [name]: value.trimStart(),
      }));
    }
  };

  const handleSubmit = (event) => {
    setSubLoader(true)
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity()) {
      setValidated(false);
      const type = Boolean(mode) ? "postWithToken" : "putWithToken";
      const formData = new FormData();
      formData.append("description", states?.description);
      formData.append("is_active", states?.is_active ? 'true' : 'false');


      if (!Boolean(mode) && states?.id) {
        formData.append("id", states?.id);
      }
      api[type](`${serverURL}review/`, formData)
        .then(async (res) => {
          setModalShow(false)
          setStates({})
          form.reset();
          setSubLoader(false)
          if (res?.data?.success === true) {
            toast.success(res?.data?.message);
            getReview();
          } else if (res?.data?.success === false) {
            if (typeof res?.data?.message === "string")
              toast.error(res?.data?.message);
          }
        })
        .catch((e) => {
          setSubLoader(false)
          errorResponse(e);
        });
    } else {
      setValidated(true);
      setSubLoader(false)
      event.stopPropagation();
    }
  };

  return (
    <>
      <Card className="user-list">
        <Card.Header>
          <div className='d-flex justify-content-between align-items-center'>
            <Card.Title as="h4">{props?.title || ""}</Card.Title>
            <div className='d-flex align-items-center'>
              <header className="navbar pcoded-header" style={{ backgroundColor: "#fff" }}>
                <NavSearch searchText={searchText} setSearchText={setSearchText} />
              </header>
              {/* <Button variant={"outline-primary"} className='m-0' onClick={() => setModalShow(true)}>
                {"Add"}
              </Button> */}
            </div>
          </div>
        </Card.Header>
        <Card.Body>
          <Table responsive hover className='product-table'>
            <thead>
              <tr>
                <th>No</th>
                <th>User Email</th>
                <th>Product Name</th>
                <th>Description</th>
                <th>Rating</th>
                <th>Is Active</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {Boolean(loading) ?
                <tr>
                  <td colSpan={6} className='text-center'>
                    <Loader loading={loading} />
                  </td>
                </tr>
                :
                Boolean(data?.length) ? data?.map((item, index) =>
                  <tr>
                    <td>{(10 * (page - 1)) + (index + 1)}</td>
                    <td>
                      <h6 className="m-0">{item?.email || "-"}</h6>
                    </td>
                    <td>
                      <h6 className="m-0">{item?.product_name || "-"}</h6>
                    </td>
                    <td>
                      <h6 className="m-0">{item?.description || "-"}</h6>
                    </td>
                    <td>
                      <h6 className="m-0">{item?.rate || "-"}</h6>
                    </td>
                    <td>
                      <h6 className="m-0">{item?.is_active?.toString()}</h6>
                    </td>
                    <td>
                      <div className='d-flex align-items-center gap-3'>
                        <div className='cursor-pointer' onClick={() => { setMode(false); setStates(item); setModalShow(true) }}>
                          <i className="feather icon-edit" title='Edit' />
                        </div>
                        {/* <div className='cursor-pointer' onClick={() => { setMode(false); setStates(item); setDeleteModalShow(true) }}>
                          <i className="feather icon-trash-2" title='Delete' />
                        </div> */}
                      </div>
                    </td>
                  </tr>
                )
                  :
                  <tr>
                    <td colSpan={6} className='text-center'>
                      There are no records available at the moment.
                    </td>
                  </tr>
              }
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      {Boolean(data?.length) && paginationData?.total_pages > 1 &&
        <PaginationC data={paginationData}
          onPageChange={(newPage) => {
            setPage(newPage);
          }} />
      }


      {/* add modal */}
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
            <Card.Header className='d-flex justify-content-between align-items-center'>
              <Card.Title as="h5">{Boolean(mode) ? "Add " : "Edit "} {props?.title}</Card.Title>
              <Modal.Header closeButton className='border-0'>
              </Modal.Header>
            </Card.Header>
            <Card.Body>
              {Boolean(subLoader) && <Loader loading={subLoader} />}
              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Form.Group className="mb-4" as={Row} controlId="formHorizontalName">
                  <Form.Label column sm={3}>
                    Description
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control as="textarea" rows={3} placeholder="Enter description" required value={states?.description || ""} name='description' onChange={handleChange} />
                    <Form.Control.Feedback type="invalid">Please enter description.</Form.Control.Feedback>
                    {/* <div>The most helpful reviews are 500 characters.</div> */}
                  </Col>
                </Form.Group>
                <Form.Group className="mb-4" as={Row} controlId="formHorizontalIsActive">
                  <Form.Label as="legend" column lg={3}>
                    Is Active
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Check
                      type="checkbox"
                      label="True"
                      name="is_active"
                      checked={states?.is_active || false}
                      onChange={handleChange}
                    />
                  </Col>
                </Form.Group>
                <div className='d-flex justify-content-end'>
                  <Button type='submit' className='m-0'>{Boolean(mode) ? "Save" : "Update"}</Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

    </>
  )
}

export default ProductReview